import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
/** Условие сортировки */
let PitRequestCriteriaSort = class PitRequestCriteriaSort {
    constructor(fields) {
        if (fields)
            Object.assign(this, fields);
    }
    get field() {
        return this._field;
    }
    set field(value) {
        this._field = value;
    }
    get direction() {
        return this._direction;
    }
    set direction(value) {
        this._direction = value;
    }
    get caseSens() {
        return this._caseSens;
    }
    set caseSens(value) {
        this._caseSens = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "field", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitRequestCriteriaSort.prototype, "_field", void 0);
tslib_1.__decorate([
    jsonMember({ name: "direction", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitRequestCriteriaSort.prototype, "_direction", void 0);
tslib_1.__decorate([
    jsonMember({ name: "caseSens", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], PitRequestCriteriaSort.prototype, "_caseSens", void 0);
PitRequestCriteriaSort = tslib_1.__decorate([
    jsonObject,
    tslib_1.__metadata("design:paramtypes", [Object])
], PitRequestCriteriaSort);
export { PitRequestCriteriaSort };
